export default __webpack_public_path__ + "static/media/daysful-logo-invert.af7e51dd.png";